import { invalidateBillingCaches } from '../services/api';
import type { RefreshAuthOptions } from '../context/AuthContext';

/**
 * Re-read billing state after a plan mutation (checkout, change-plan, resume).
 *
 * An unforced refresh is throttled for 60s and returns the cached
 * pre-mutation status (BILL-24). Clearing the caches and forcing the refresh
 * makes `/api/billing/refresh` read Stripe directly, so the new plan shows
 * even when the webhook has not landed yet. The forced `refreshAuth` already
 * calls `billingAPI.refresh({ force: true })`; don't add a second refresh.
 */
export async function syncBillingAfterMutation(
  refreshAuth: (options?: RefreshAuthOptions) => Promise<void>,
): Promise<void> {
  invalidateBillingCaches();
  await refreshAuth({ forceBillingRefresh: true });
}
